import { targetAttributes } from 'src/js/modules/element-settings/constants/target-attributes';

const getColumnClipPath = (element, elementBounds) => {
  if (!element?.matches?.('ws-column')) return null;

  const columnsContainer = element.closest(`ws-columns[${targetAttributes.NO_WRAP}]`);
  if (!columnsContainer) return null;

  const columnRect = element.getBoundingClientRect();
  const containerRect = columnsContainer.getBoundingClientRect();
  const elementLeft = elementBounds.left;
  const elementRight = elementBounds.left + elementBounds.width;
  const visibleLeft = Math.max(containerRect.left, columnRect.left);
  const visibleRight = Math.min(containerRect.right, columnRect.right);
  const clipLeft = Math.max(visibleLeft - elementLeft, 0);
  const clipRight = Math.max(elementRight - visibleRight, 0);

  // Clip only horizontal overflow for no-wrap rows.
  return `inset(0px ${Math.round(clipRight)}px 0px ${Math.round(clipLeft)}px)`;
};

export default getColumnClipPath;
